import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * LOS INVOICES QUE EL ESTIMADOR TIENE QUE INCLUIR (dueño 2026-10-07): la lista vive en la revisión del claim
 * (`estimate_reviews.invoices_json`). Varios módulos de la misma tarjeta la leen y la escriben (Info pending,
 * Contractor invoices, Contractor documents, y la caja de instrucciones), así que hay UN estado por claim con
 * suscriptores: marcar en un módulo se ve al instante en los demás, y se pide al servidor una sola vez.
 */
export type InvoiceRef = { kind: 'info_pending' | 'contractor_invoice' | 'contractor_doc'; id: string; label: string; amount_cents: number | null; file_id: string | null; file_name: string | null };

type Estado = { list: InvoiceRef[] | null; subs: Set<(l: InvoiceRef[]) => void>; cargando: boolean };
const estados = new Map<string, Estado>();
const de = (claimId: string): Estado => {
  let e = estados.get(claimId);
  if (!e) { e = { list: null, subs: new Set(), cargando: false }; estados.set(claimId, e); }
  return e;
};
function publicar(claimId: string, list: InvoiceRef[]) { const e = de(claimId); e.list = list; e.subs.forEach((f) => f(list)); }
async function cargar(claimId: string) {
  const e = de(claimId);
  if (e.cargando) return;
  e.cargando = true;
  try { const r = await api.get<{ review: { invoices?: InvoiceRef[] } | null }>(`/api/claims/${claimId}/estimate-review`); publicar(claimId, r.review?.invoices ?? []); }
  catch { publicar(claimId, []); }
  finally { e.cargando = false; }
}

export function useEstimatorInvoices(claimId: string) {
  const [list, setList] = useState<InvoiceRef[] | null>(() => de(claimId).list);
  useEffect(() => {
    const e = de(claimId);
    e.subs.add(setList);
    if (e.list) setList(e.list); else void cargar(claimId);
    return () => { e.subs.delete(setList); };
  }, [claimId]);
  const marcado = (kind: InvoiceRef['kind'], id: string) => Boolean(list?.some((x) => x.kind === kind && x.id === id));
  /** Marca o desmarca: se publica optimista y se manda la lista entera; si el servidor falla, se vuelve atrás. */
  const toggle = async (item: InvoiceRef, on: boolean) => {
    const actual = de(claimId).list ?? [];
    const sin = actual.filter((x) => !(x.kind === item.kind && x.id === item.id));
    const next = on ? [...sin, item] : sin;
    publicar(claimId, next);
    try { const r = await api.put<{ review: { invoices?: InvoiceRef[] } }>(`/api/claims/${claimId}/estimate-review/invoices`, { invoices: next }); publicar(claimId, r.review?.invoices ?? next); }
    catch { publicar(claimId, actual); }
  };
  return { list, marcado, toggle };
}
